import { render, staticRenderFns } from "./myProfile.vue?vue&type=template&id=64b35ba0&"
import script from "./myProfile.js?vue&type=script&lang=js&"
export * from "./myProfile.js?vue&type=script&lang=js&"
import style0 from "./myProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports